import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-[80%] w-full h-full" }
const _hoisted_2 = { class: "text-center pb-2 font-semibold" }
const _hoisted_3 = { class: "border-2 h-full overflow-y-auto border-opacity-10 rounded-lg py-2 max-h-[50rem]" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "pl-4 font-medium" }
const _hoisted_8 = { class: "w-6.5 pr-4" }
const _hoisted_9 = { class: "flex justify-center" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "pl-4 py-2 font-medium" }
const _hoisted_13 = { class: "inline-flex items-center mr-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "inline-flex rounded-full p-2.5"
}
const _hoisted_16 = { class: "w-6.5 pr-4 py-2" }
const _hoisted_17 = { class: "flex justify-center" }
const _hoisted_18 = {
  colspan: "2",
  class: "p-0"
}
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "pl-16 py-2 text-sm text-gray-700" }
const _hoisted_22 = { class: "w-6.5 pr-4 py-2" }
const _hoisted_23 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomCheckbox = _resolveComponent("CustomCheckbox")!
  const _component_ExpandIcon = _resolveComponent("ExpandIcon")!
  const _component_ExpandCollapseTransition = _resolveComponent("ExpandCollapseTransition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.batchTabIsActive ? _ctx.$t('views.reports.selectSitesPage.selectBatchesConditions') : _ctx.$t('views.reports.selectSitesPage.selectFarmsConditions')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("thead", null, null, -1)),
        (_ctx.batchTabIsActive)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchSites, (site) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: site.site_ids,
                  class: "hover:bg-gray-100 cursor-pointer",
                  onClick: ($event: any) => (_ctx.onBatchClicked(site))
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(site.name), 1),
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_CustomCheckbox, {
                        checked: _ctx.computedState.siteIds.includes(site.site_ids),
                        "onUpdate:checked": ($event: any) => (_ctx.onBatchClicked(site))
                      }, null, 8, ["checked", "onUpdate:checked"])
                    ])
                  ])
                ], 8, _hoisted_6))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmSites, (farm) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: _ctx.getFarmKey(farm)
                }, [
                  _createElementVNode("tr", {
                    class: "hover:bg-gray-100 cursor-pointer",
                    onClick: ($event: any) => (_ctx.onFarmClicked(farm))
                  }, [
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, [
                        (farm.barns?.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "inline-flex rounded-full p-2.5 hover:bg-gray-200 transition-colors",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleFarmExpanded(farm)), ["stop"])
                            }, [
                              _createVNode(_component_ExpandIcon, {
                                color: "black",
                                expand: _ctx.isFarmExpanded(farm),
                                class: "w-3.5 h-3.5"
                              }, null, 8, ["expand"])
                            ], 8, _hoisted_14))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, _cache[0] || (_cache[0] = [
                              _createElementVNode("span", { class: "inline-block w-3.5 h-3.5" }, null, -1)
                            ])))
                      ]),
                      _createElementVNode("span", null, _toDisplayString(farm.name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_CustomCheckbox, {
                          checked: _ctx.isFarmChecked(farm),
                          indeterminate: _ctx.isFarmIndeterminate(farm),
                          "onUpdate:checked": ($event: any) => (_ctx.onFarmClicked(farm))
                        }, null, 8, ["checked", "indeterminate", "onUpdate:checked"])
                      ])
                    ])
                  ], 8, _hoisted_11),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, [
                      _createVNode(_component_ExpandCollapseTransition, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            _createElementVNode("table", _hoisted_19, [
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(farm.barns || [], (barn) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: _ctx.getBarnKey(farm, barn),
                                    class: "hover:bg-gray-50 cursor-pointer",
                                    onClick: ($event: any) => (_ctx.onBarnClicked(farm, barn))
                                  }, [
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(barn.name), 1),
                                    _createElementVNode("td", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _createVNode(_component_CustomCheckbox, {
                                          checked: _ctx.isBarnSelected(farm, barn),
                                          "onUpdate:checked": ($event: any) => (_ctx.onBarnClicked(farm, barn))
                                        }, null, 8, ["checked", "onUpdate:checked"])
                                      ])
                                    ])
                                  ], 8, _hoisted_20))
                                }), 128))
                              ])
                            ])
                          ], 512), [
                            [_vShow, _ctx.isFarmExpanded(farm)]
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ], 64))
              }), 128))
            ]))
      ])
    ])
  ]))
}